module.exports = __webpack_public_path__ + "img/nfl.67976aba.png";